<template>
  <!-- 轮播图列表父组件 -->
  <div class="carousel-index">
    <!-- 引用公共表格组件 -->
    <!-- 表格 -->
    <div v-if="rightcom !== 'ArticleListIndex'">
      <el-button
        class="custom-btn none"
        size="small"
        @click="handleBackClick()"
      >
        <i class="el-icon-arrow-left primary-color"></i> 返回</el-button
      >
    </div>

    <div v-if="rightcom === 'ArticleListIndex'">
      <CustomTable
        :tableData="tableData"
        :tableHeaders="tableHeaders"
        :showSelection="true"
        :pagination="pagination"
        :loading="tableLoading"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <!-- 顶部操作按钮插槽 -->
        <template #top-actions>
          <div class="table-buttons">
            <CustomButton
              v-for="button in actionButtons"
              :key="button.id"
              :text="button.text"
              size="medium"
              :icon="button.icon"
              fontSize="14px"
              :customStyle="button.customStyle"
              @click="handleClick(button)"
            />
          </div>
        </template>
        <template #action>
          <div>
            <el-button
              class="custom-btn none"
              size="small"
              @click="handleClick()"
              >上架</el-button
            >
            <el-button
              class="custom-btn none"
              size="small"
              @click="handleClick()"
              >编辑</el-button
            >
            <el-button
              class="custom-btn none"
              size="small"
              style="margin-left: 10px"
              @click="handleClick()"
              >删除</el-button
            >
          </div>
        </template>
        <template #status="{ row, column, index }">
          <div v-if="column.property === 'status'">
            <!-- 根据状态值显示不一样的小按钮颜色 -->
            <span class="status one" v-if="row[column.property] == 1"
              >已发布</span
            >
            <span class="status two" v-if="row[column.property] == 2"
              >草稿</span
            >
            <span class="status three" v-if="row[column.property] == 3"
              >已下架</span
            >
          </div>
        </template>
      </CustomTable>
    </div>
    <div v-else>
      <ArticleListEdit :datas="selectedRows[0]" />
    </div>
    <!-- 发布弹窗-->
    <CustomElDialog
      :visible.sync="showDialog"
      width="400px"
      height="410px"
      :dialog-bg-gradient="dialogGradient"
    >
      <template #content>
        <div
          class="dialog-content"
          :style="{
            backgroundImage: 'url(' + $serverImgUrl + 'popup9.png' + ')',
          }"
        >
          <div class="publish-selection">
            <h3 class="selection-title">请选择发布至</h3>
            <p class="selection-subtitle">选择发布渠道，进行后续发布操作。</p>

            <!-- 发布推文选项 -->
            <div
              class="publish-option"
              @click="selectedOptionChange(1)"
              :class="{
                'primary-option': selectedOption == 1,
                border: selectedOption == 2,
              }"
            >
              <div class="option-content">
                <h4>发布推文</h4>
                <p>将内容发布为推文</p>
              </div>
              <i
                v-if="selectedOption == 1"
                class="iconfont icon-youjiantou"
                style="font-size: 24px"
              ></i>
              <i
                v-else
                class="iconfont icon-youjiantou_huaban"
                style="font-size: 24px; color: #348cf8"
              ></i>
            </div>

            <!-- 发布推文且同步至公众号选项 -->
            <div
              class="publish-option"
              @click="selectedOptionChange(2)"
              :class="{
                'primary-option': selectedOption == 2,
                border: selectedOption == 1,
              }"
            >
              <div class="option-content">
                <h4>发布推文且同步至公众号</h4>
                <p>订阅号每年最多发 365 次推文</p>
                <p>服务号每年最多 48 次，每月4次</p>
              </div>
              <i
                v-if="selectedOption == 1"
                class="iconfont icon-youjiantou_huaban"
                style="font-size: 24px; color: #348cf8"
              ></i>
              <i
                v-else
                class="iconfont icon-youjiantou"
                style="font-size: 24px"
              ></i>
            </div>
          </div>
        </div>
      </template>
    </CustomElDialog>
  </div>
</template>
<script>
import { color } from "echarts";
// 引入文章表格的列配置
import { articleTableHeaders } from "@/utils/defaultData";
export default {
  // name: "ArticleListIndex",
  props: {
    datas: Object,
  },
  data() {
    return {
      // 动态渐变背景
      dialogGradient: "linear-gradient(180deg, #DDF1FF 0%, #FFFFFF 100%)",
      backgroundImage: this.$serverImgUrl + "popup9.png",
      selectedOption: 1,
      // 发布弹窗
      showDialog: false,
      rightcom: "ArticleListIndex",
      pagination: {
        total: 16,
        currentPage: 1,
        pageSize: 10,
      },
      scope: {},
      // 选中的行数据
      selectedRows: [],
      columns: [],
      tableLoading: false,
      // 新增按钮配置数组
      actionButtons: [
        {
          id: "add",
          text: "新增",
          icon: "el-icon-plus",
          handler: "handleAddClick",
          customStyle: {
            backgroundColor: "#E8F4FF",
            borderRadius: "5px",
            cursor: "pointer",
            color: "#508EF2",
            border: "2px solid #508EF2",
          },
        },
        {
          id: "release",
          text: "发布",
          icon: "el-icon-edit",
          handler: "handleReleaseClick",
          customStyle: {
            backgroundColor: "#FFF0E9",
            borderRadius: "5px",
            cursor: "pointer",
            color: "#FF7225",
            border: "2px solid #FF7225",
          },
        },
        {
          id: "edit",
          text: "修改",
          icon: "el-icon-edit",
          handler: "handleEditClick",
          customStyle: {
            backgroundColor: "#E6F7F1",
            borderRadius: "5px",
            cursor: "pointer",
            color: "#43C393",
            border: "2px solid #43C393",
          },
        },
        {
          id: "delete",
          text: "删除",
          icon: "el-icon-delete",
          handler: "handleDeleteClick",
          customStyle: {
            backgroundColor: "#FEEEEE",
            borderRadius: "5px",
            cursor: "pointer",
            color: "#F88484",
            border: "2px solid #F88484",
          },
        },
      ],
      tableData: [
        {
          articleId: "1001",
          articleName: "元嘉草草，封...",
          readCount: 100,
          forwardCount: 50,
          collectCount: 30,
          commentCount: 20,
          publishTime: "2025-09-11 10:00:00",
          publishUser: "admin",
          status: 1,
        },
        {
          articleId: "1002",
          articleName: "元嘉草草，封...",
          readCount: 100,
          forwardCount: 50,
          collectCount: 30,
          commentCount: 20,
          publishTime: "2025-09-11 10:00:00",
          publishUser: "admin",
          status: 2,
        },
        {
          articleId: "1003",
          articleName: "元嘉草草，封...",
          readCount: 100,
          forwardCount: 50,
          collectCount: 30,
          commentCount: 20,
          publishTime: "2025-09-11 10:00:00",
          publishUser: "admin",
          status: 3,
        },
        {
          articleId: "1004",
          articleName: "元嘉草草，封...",
          readCount: 100,
          forwardCount: 50,
          collectCount: 30,
          commentCount: 20,
          publishTime: "2025-09-11 10:00:00",
          publishUser: "admin",
          status: 2,
        },
        {
          articleId: "1005",
          articleName: "元嘉草草，封...",
          readCount: 100,
          forwardCount: 50,
          collectCount: 30,
          commentCount: 20,
          publishTime: "2025-09-11 10:00:00",
          publishUser: "admin",
          status: 1,
        },
      ],
      // 使用文章表格的列配置
      tableHeaders: articleTableHeaders,
    };
  },
  create() {
    this.getList();
  },
  mounted() {
    console.log("打印默认数据", this.tableHeaders);
  },
  methods: {
    // 选项切换方法
    selectedOptionChange(option) {
      this.selectedOption = option;
    },
    // 返回上一页
    handleBackClick() {
      console.log("点击了返回按钮", this.rightcom);
      // 可以在这里添加返回逻辑
      this.rightcom = "ArticleListIndex";
    },
    // 按钮点击处理方法
    handleClick(button) {
      console.log("点击了按钮", button);
      // 可以在这里添加按钮点击逻辑
      if (button.handler) {
        this[button.handler](button);
      }
    },
    // 按钮点击处理方法
    handleAddClick(button) {
      console.log("点击了新增按钮");
      this.rightcom = "ArticleListEdit";
      // 可以在这里添加新增逻辑
    },

    handleEditClick(button) {
      console.log("点击了修改按钮", button, this.selectedRows);
      // 可以在这里添加修改逻辑，通常需要检查是否有选中行
      if (this.selectedRows.length === 0) {
        this.$message.warning("请先选择要修改的数据");
        return;
      }
      // 修改逻辑...
      this.rightcom = "ArticleListEdit";
    },
    // 发布文章
    handleReleaseClick(button) {
      console.log("点击了发布按钮", button, this.selectedRows);
      this.showDialog = true;
      // 可以在这里添加发布逻辑，通常需要检查是否有选中行
      // if (this.selectedRows.length === 0) {
      //   this.$message.warning("请先选择要发布的数据");
      //   return;
      // }
      // // 发布逻辑...
      // this.showDialog = true;
    },

    handleDeleteClick() {
      console.log("点击了删除按钮");
      // 可以在这里添加删除逻辑，通常需要检查是否有选中行并二次确认
      // if (this.selectedRows.length === 0) {
      //   this.$message.warning("请先选择要删除的数据");
      //   return;
      // }
      // 删除确认对话框和删除逻辑...
      this.$confirm(
        "确认删除选中的" + this.selectedRows.length + "条数据吗？",
        "删除确认",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          // 执行删除操作
          this.$message({
            type: "success",
            message: "删除成功",
          });
          // 刷新数据列表
          this.getList();
        })
        .catch(() => {
          // 取消删除操作
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 处理每页显示条数变化
    handleSizeChange(newPagination) {
      console.log("每页条数变化", newPagination);
      this.pagination = newPagination;

      // this.getList();
    },
    // 处理页码变化
    handleCurrentChange(newPagination) {
      this.tableLoading = true;
      console.log("页码变化", newPagination);
      this.tableData = [
        {
          name: "最后加的",
          type: "男",
          image:
            "https://beihai-food.oss-cn-beijing.aliyuncs.com/pic/avatar.png",
          uploadTime: "2025-09-11 10:00:00",
          uploadUser: "admin",
          status: false,
        },
      ];
      // this.pagination = newPagination;
      // this.getList();
    },
    // 处理选择事件
    handleSelectionChange(selection) {
      this.selectedRows = selection;
      console.log("父组件中选项变更了", this.selectedRows);
    },
    handleStatusChange(row, prop, val) {
      console.log("改变了", row, prop, val);
    },
    getList() {
      // 获取数据
      this.tableLoading = true;
      fetchList(
        Object.assign(
          { currrent: this.page.current, size: this.page.size },
          this.searchForm
        )
      )
        .then((res) => {
          this.tableData = res.data.records;
          this.total = res.data.total;
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.carousel-index {
  padding: 10px;
}
.table-buttons {
  display: flex;
  gap: 10px;
  float: right;
  padding-bottom: 10px;
}
.status {
  display: inline-block;
  width: 60px;
  padding: 2px 5px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  color: #fff;
}
.status.one {
  background-color: #e6f7f1;
  color: #43c393;
}
.status.two {
  background-color: #e5effd;
  color: #348cf8;
}
.status.three {
  background-color: #fff5e6;
  color: #ff9900;
}

/* 发布选项弹窗样式 */
.dialog-content {
  background-repeat: no-repeat;
}

.publish-selection {
  width: 100%;
}

.selection-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  text-align: center;
  margin: 0 0 10px 0;
}

.selection-subtitle {
  font-size: 14px;
  color: #666;
  text-align: center;
  margin: 0 0 30px 0;
}
.publish-option.border {
  border: 1px solid #348cf8;
}
.publish-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  margin-bottom: 15px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.publish-option:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.primary-option {
  background-color: #409eff;
  color: white;
}

.secondary-option {
  background-color: #f0f9ff;
  color: #333;
  border: 1px solid #e1f3ff;
}

.option-content h4 {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 8px 0;
}

.primary-option .option-content h4 {
  color: white;
}

.secondary-option .option-content h4 {
  color: #333;
}

.option-content p {
  font-size: 14px;
  margin: 4px 0;
  line-height: 1.4;
}

.primary-option .option-content p {
  color: rgba(255, 255, 255, 0.9);
}

.secondary-option .option-content p {
  color: #666;
}

.publish-option i {
  font-size: 18px;
}

.primary-option i {
  color: white;
}

.secondary-option i {
  color: #409eff;
}
</style>
